module.exports = __webpack_public_path__ + "static/media/Juj Sandhu.652ac0a0.jpg";